import { AK, SK } from "../constants/index";
import axios from "axios";
import { AxioseGET, AxiosGET, AxiosMockupGET } from "./axioscall";
import {
  handleSetCategoryInfoStorageItems,
  handleSetColorCodesInfoStorageItems,
  handleSetProductsColorCodesInfoStorageItems,
  handleSetProductsInfoStorageItems,
  handleSetProductsSizeInfoStorageItems,
  handleSetSizeInfoStorageItems,
  handleSetVersionManagerStorageItems,
} from "./storageManager";

let cartinfodefalults = {
  cartcount: 0,
  cartquantitycount: 0,
  products: [],
  cartprice: 0,
  subtotal: 0,
  mrptotal: 0,
  shipping: 0,
  ordertotal: 0,
  total: 0,
};
export const handleFetchVersionManagerData = async (setVersionManagerData) => {
  return await AxiosGET(AK.VERSIONMANAGERJSONAPI)
    .then((res) => {
      // console.log("res");
      // console.log(res);
      if (res.data != typeof undefined && res.data != null) {
        setVersionManagerData(res.data);

        return res.data;
      }
    })
    .catch((error) => {
      return null;
    });
};

export const handleFetchCategoryData = async (
  setFormLoader,
  setCategoryListData
) => {
  setFormLoader(true);
  await AxiosGET(AK.CATEGORYJSONAPI)
    .then((res) => {
      if (res.data != typeof undefined && res.data != null) {
        setCategoryListData(res.data);
        handleSetCategoryInfoStorageItems(res.data);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleFetchColorCodesData = async (
  setFormLoader,
  setColorCodesListData
) => {
  setFormLoader(true);

  await AxiosGET(AK.COLORCODESJSONAPI)
    .then((res) => {
      // console.log(res);
      if (res.data != typeof undefined && res.data != null) {
        setColorCodesListData(res.data);
        handleSetColorCodesInfoStorageItems(res.data);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleFetchSizeData = async (setFormLoader, setSizeListData) => {
  setFormLoader(true);

  await AxiosGET(AK.SIZEJSONAPI)
    .then((res) => {
      // console.log(res);
      if (res.data != typeof undefined && res.data != null) {
        setSizeListData(res.data);
        handleSetSizeInfoStorageItems(res.data);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleFetchProductsSizeData = async (
  setFormLoader,
  setProductsSizeListData
) => {
  setFormLoader(true);

  await AxiosGET(AK.PRODUCTSSIZESJSONAPI)
    .then((res) => {
      // console.log(res);
      if (res.data != typeof undefined && res.data != null) {
        setProductsSizeListData(res.data);
        handleSetProductsSizeInfoStorageItems(res.data);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleFetchProductsColorCodesData = async (
  setFormLoader,
  setProductsColorCodesListData
) => {
  setFormLoader(true);

  await AxiosGET(AK.PRODUCTSCOLORCODESJSONAPI)
    .then((res) => {
      // console.log(res);
      if (res.data != typeof undefined && res.data != null) {
        setProductsColorCodesListData(res.data);
        handleSetProductsColorCodesInfoStorageItems(res.data);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleFetchProductsData = async (
  setFormLoader,
  setProductsListData
) => {
  setFormLoader(true);
  const productpayload = {};

  await AxioseGET(AK.ePRODUCTSJSONAPI)
    .then((res) => {
      if (res.data != typeof undefined && res.data != null) {
        let products = res.data;
        if (!localStorage) return;
        const infodata = JSON.parse(localStorage.getItem(SK.CARTINFODATA));
        if (infodata !== null && infodata.products !== null) {
          infodata.products.map((infoprod) => {
            products.filter((prod) => {
              if (prod.id === infoprod.id) {
                prod["addtocart"] = true;
                prod["cartquantity"] = infoprod.cartquantity;
                return true;
              }
              return false;
            });
          });
        }
        setProductsListData(products);
        handleSetProductsInfoStorageItems(products);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleFetchProductsDataSliced = async (
  setFormLoader,
  setProductsListData,
  setProductsListDisplayData,
  productsListDisplayDataCount
) => {
  setFormLoader(true);
  const productpayload = {};

  await AxioseGET(AK.ePRODUCTSJSONAPI)
    .then((res) => {
      if (res.data != typeof undefined && res.data != null) {
        if (!localStorage) return;
        let products = res.data;
        const infodata = JSON.parse(localStorage.getItem(SK.CARTINFODATA));
        if (infodata !== null && infodata.products !== null) {
          infodata.products.map((infoprod) => {
            products.filter((prod) => {
              if (prod.id === infoprod.id) {
                prod["addtocart"] = true;
                prod["cartquantity"] = infoprod.cartquantity;
                return true;
              }
              return false;
            });
          });
        }
        setProductsListData(products);
        setProductsListDisplayData(
          products.slice(0, productsListDisplayDataCount)
        );
        handleSetProductsInfoStorageItems(products);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const updateProductInfoData = async (
  setFormLoader,
  productinfo,
  setProductInfoData
) => {
  setFormLoader(true);
  const productpayload = {};
  if (productinfo != null) {
    if (!localStorage) return;
    const infodata = JSON.parse(localStorage.getItem(SK.CARTINFODATA));
    if (infodata !== null && infodata.products !== null) {
      infodata.products.map((infoprod) => {
        if (productinfo.id === infoprod.id) {
          productinfo["addtocart"] = true;
          productinfo["cartquantity"] = infoprod.cartquantity;
          return true;
        }
        return false;
      });
    }
    setProductInfoData(productinfo);
  }

  await AxioseGET(AK.ePRODUCTSJSONAPI)
    .then((res) => {
      if (res.data != typeof undefined && res.data != null) {
        let products = res.data;
        if (!localStorage) return;
        const infodata = JSON.parse(localStorage.getItem(SK.CARTINFODATA));
        if (infodata !== null && infodata.products !== null) {
          infodata.products.map((infoprod) => {
            products.filter((prod) => {
              if (prod.id === infoprod.id) {
                prod["addtocart"] = true;
                prod["cartquantity"] = infoprod.cartquantity;
                return true;
              }
              return false;
            });
          });
        }
        setProductInfoData(products);
        handleSetProductsInfoStorageItems(products);
        setFormLoader(false);
      }
    })
    .catch((error) => { });
};

export const handleSetCartInfoStorageItems = async (cartinfoData) => {
  if (!cartinfoData || typeof cartinfoData !== 'object') {
    cartinfoData = { ...cartinfodefalults };
  }

  // Ensure products is always an array
  if (!Array.isArray(cartinfoData.products)) {
    cartinfoData.products = [];
  }

  await cartCalculation(cartinfoData);
  if (!localStorage) return;
  localStorage.setItem(SK.CARTINFODATA, JSON.stringify(cartinfoData));
};

export const handleGetCartInfoStorageItems = async (setCartInfoData) => {
  let items = null;
  try {
    const raw = localStorage.getItem(SK.CARTINFODATA);
    items = raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error("Failed to parse cart data", e);
    items = null;
  }

  // Always fallback to safe defaults
  const safeData = items && typeof items === 'object'
    ? { ...cartinfodefalults, ...items, products: Array.isArray(items.products) ? items.products : [] }
    : cartinfodefalults;

  setCartInfoData(safeData);
  return safeData;
};

export const handleCartPlus = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;
  product["cartquantity"] = product["cartquantity"] + 1;
  if (
    cartinfoData.products.filter((res) => {
      if (res.id === product.id) {
        res["cartquantity"] = product["cartquantity"];
        return true;
      }
      return false;
    }).length > 0
  ) {
  } else {
    product["cartquantity"] = 1;
    cartinfoData.products.push(product);
  }
  //console.log(JSON.stringify(cartinfoData));
  await cartCalculation(cartinfoData);
  await handleSetCartInfoStorageItems(cartinfoData);
  setCartInfoData(cartinfoData);
  // console.log('******************');
  // console.log(cartinfoData);
  // setCount({ ...count, count: count + 1 });
};

export const handleCartMinus = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;
  product["cartquantity"] = product["cartquantity"] - 1;
  if (product["cartquantity"] <= 0) {
    product["addtocart"] = false;
    let cartinfoprod = cartinfoData.products.filter(
      (res) => res.id === product.id
    );
    var index = cartinfoData.products.indexOf(cartinfoprod);
    cartinfoData.products.splice(index, 1);
  } else {
    cartinfoData.products.filter((res) => {
      if (res.id === product.id) {
        res["cartquantity"] = res["cartquantity"] - 1;
        return true;
      }
      return false;
    });
  }
  //console.log(JSON.stringify(cartinfoData));
  await cartCalculation(cartinfoData);
  await handleSetCartInfoStorageItems(cartinfoData);
  setCartInfoData(cartinfoData);
  // console.log('******************');
  // console.log(cartinfoData);
  // setCount({ ...count, count: count + 1 });
};

export const handleCartCartInfoPlus = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;
  cartinfoData.products.filter((res) => {
    if (res.id === product.id) {
      res["cartquantity"] = res["cartquantity"] + 1;
      return true;
    }
    return false;
  });
  await cartCalculation(cartinfoData);
  await handleSetCartInfoStorageItems(cartinfoData);
  setCartInfoData(cartinfoData);
  // console.log('******************');
  // console.log(cartinfoData);
  // setCount({ ...count, count: count + 1 });
};

export const handleCartCartInfoMinus = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;
  cartinfoData.products.filter((res) => {
    if (res.id === product.id) {
      res["cartquantity"] = res["cartquantity"] - 1;
      if (res["cartquantity"] <= 0) {
        var index = cartinfoData.products.indexOf(product);
        cartinfoData.products.splice(index, 1);
      }
      return true;
    }
    return false;
  });

  await cartCalculation(cartinfoData);
  await handleSetCartInfoStorageItems(cartinfoData);
  setCartInfoData(cartinfoData);
  // console.log('******************');
  // console.log(cartinfoData);
  // setCount({ ...count, count: count + 1 });
};

export const handleProductInfoPlus = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;
  //console.log(JSON.stringify(cartinfoData));
  if (product?.cartquantity == null || product?.cartquantity == undefined) {
    product["cartquantity"] = 1;
  } else {
    product["cartquantity"] = product["cartquantity"] + 1;
  }

  // setCount({ ...count, count: count + 1 });
};

export const handleProductInfoMinus = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;
  //console.log(JSON.stringify(cartinfoData));
  if (product?.cartquantity == null || product?.cartquantity == undefined) {
    product["cartquantity"] = 0;
  } else {
    product["cartquantity"] = product["cartquantity"] - 1;
  }

  if (
    product?.cartquantity == null ||
    product?.cartquantity == undefined ||
    product["cartquantity"] <= 0
  ) {
    product["addtocart"] = false;
    let cartinfoprod = cartinfoData.products.filter(
      (res) => res.id === product.id
    );
    var index = cartinfoData.products.indexOf(cartinfoprod);
    cartinfoData.products.splice(index, 1);
  } else {
    cartinfoData.products.filter((res) => {
      if (res.id === product.id) {
        res["cartquantity"] = product["cartquantity"];
        return true;
      }
      return false;
    });
  }
  //console.log(JSON.stringify(cartinfoData));
  await cartCalculation(cartinfoData);
  await handleSetCartInfoStorageItems(cartinfoData);
  setCartInfoData(cartinfoData);
  // console.log('******************');
  // console.log(cartinfoData);
  // setCount({ ...count, count: count + 1 });

  // setCount({ ...count, count: count + 1 });
};


export const handleProductInfoAddtoCart = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  count
) => {

  let cart = cartinfoData ?? { ...cartinfodefalults };
  if (!Array.isArray(cart.products)) cart.products = [];

  const productToAdd = {
    ...product,
    cartquantity: Number(product.cartquantity) > 0 ? Number(product.cartquantity) : 1,
    addtocart: true, // UI flag
  };
  const existingIndex = cart.products.findIndex(
    (p) =>
      p.id === productToAdd.id &&
      p.selectedVariation === productToAdd.selectedVariation
  );
  if (existingIndex > -1) {

    cart.products = cart.products.map((p, i) =>
      i === existingIndex
        ? { ...p, cartquantity: productToAdd.cartquantity }
        : p
    );
  } else {

    cart.products = [...cart.products, productToAdd];
  }

  await cartCalculation(cart);
  await handleSetCartInfoStorageItems(cart);
  setCartInfoData(cart);
  setCount((c) => ({ ...c, count: c.count + 1 }));
  return cart;
};


export const handleProductInfoRemovetoCart = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  cartquantity,
  count,
  index // Index passed as a parameter
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;

  let updatedProducts = [...cartinfoData.products];

  // updatedProducts[index]["cartquantity"] = cartquantity;

  // Case 1: Remove product if cart quantity is 0 or less
  if (index >= 0 && index < updatedProducts.length) {
    updatedProducts.splice(index, 1); // Remove the product using the provided index
  }

  // Update cartinfoData with the new products array
  const updatedCartInfoData = {
    ...cartinfoData,
    products: updatedProducts,
  };

  // Perform calculations and updates
  await cartCalculation(updatedCartInfoData);
  await handleSetCartInfoStorageItems(updatedCartInfoData);

  // Update state and count
  setCartInfoData(updatedCartInfoData);
  setCount({ ...count, count: count + 1 });

  // console.log('******************');
  // console.log(updatedCartInfoData);
};

export const handleProductInfoUpdatetoCart = async (
  product,
  setCartInfoData,
  setCount,
  cartinfoData,
  cartquantity,
  count,
  index // Index passed as a parameter
) => {
  if (cartinfoData === null) cartinfoData = cartinfodefalults;

  let updatedProducts = [...cartinfoData.products];

  // Case 1: Remove product if cart quantity is 0 or less
  if (product["cartquantity"] <= 0) {
    product["addtocart"] = false;

    if (index >= 0 && index < updatedProducts.length) {
      updatedProducts.splice(index, 1); // Remove the product using the provided index
    }
  }
  // Case 2: Update or add the product
  else {
    // Check if the product with the same ID and variation exists
    const existingProductIndex = updatedProducts.findIndex(
      (res) =>
        res.id === product.id &&
        res.selectedVariation === product.selectedVariation
    );

    if (existingProductIndex !== -1) {
      // Update existing product's quantity
      updatedProducts[existingProductIndex]["cartquantity"] =
        product["cartquantity"];
    } else {
      // Add new product with default quantity if needed
      if (
        product?.cartquantity === undefined ||
        product["cartquantity"] === 0
      ) {
        product["cartquantity"] = 1;
      }
      updatedProducts.push(product);
    }
  }

  // Update cartinfoData with the new products array
  const updatedCartInfoData = {
    ...cartinfoData,
    products: updatedProducts,
  };

  // Perform calculations and updates
  await cartCalculation(updatedCartInfoData);
  await handleSetCartInfoStorageItems(updatedCartInfoData);

  // Update state and count
  setCartInfoData(updatedCartInfoData);
  setCount({ ...count, count: count + 1 });

  // console.log('******************');
  // console.log(updatedCartInfoData);
};

export const cartCalculation = async (cartinfoData) => {
  let shipping = 0;
  let subtotal = 0;
  let total = 0;
  let totalcartquantity = 0;
  let mrptotal = 0;

  if (!cartinfoData || !Array.isArray(cartinfoData.products)) {
    cartinfoData = { ...cartinfodefalults, products: [] };
  }

  cartinfoData.products.forEach((product) => {
    const qty = Number(product.cartquantity) || 0;
    const sp = Number(product.sp) || 0;
    const mrp = Number(product.mrp) || 0;

    totalcartquantity += qty;
    subtotal += sp * qty;
    total += sp * qty;
    mrptotal += mrp * qty;
  });

  cartinfoData.cartcount = cartinfoData.products.length;
  cartinfoData.cartquantitycount = totalcartquantity; // Fixed typo: was cartquantity
  cartinfoData.subtotal = subtotal;
  cartinfoData.mrptotal = mrptotal;
  cartinfoData.total = total;
  cartinfoData.shipping = shipping;
  cartinfoData.ordertotal = total + shipping;
};

export const handleCartRemoveAll = async (
  setCartInfoData,
  clearCartInfoData,
  setCount,
  count
) => {
  let cartinfoData = cartinfodefalults;

  //console.log(JSON.stringify(cartinfoData));
  await cartCalculation(cartinfoData);
  await handleSetCartInfoStorageItems(cartinfoData);
  setCartInfoData(cartinfoData);
  // console.log('******************');
  // console.log(cartinfoData);
  // clearCartInfoData();
  setCount({ ...count, count: count + 1 });
};
